import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "edp-input-toogle",
    templateUrl: "./edp-input-toogle.component.html",
    styleUrls: ["./edp-input-toogle.component.scss"],
})
export class EdpInputToogleComponent {
    @Input() title: string;
    @Input() description: string;
    @Input() toogleValue: boolean;
    @Input() sufix: string;
    @Output() checked: EventEmitter<boolean> = new EventEmitter();


    public onChange(event) {
        this.toogleValue = event.target.checked;
        this.checked.emit(this.toogleValue);
    }
}
